import type * as AddToBasketFailed from '@ori-events/add-to-basket-failed';
import type * as BasketUpdated from '@ori-events/basket-updated';
import type * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';

export type AddToBasketResponse =
  | AddToBasketFailed.Data
  | BasketUpdated.Data
  | ShowLoyaltyDialog.Data;

export const isAddToBasketErrorResponse = (
  response: AddToBasketResponse,
): response is AddToBasketFailed.Data =>
  typeof (response as AddToBasketFailed.Data).isSuccess === 'boolean' &&
  !(response as AddToBasketFailed.Data).isSuccess;

export const isAddToBasketLoyaltyResponseResponse = (
  response: AddToBasketResponse,
): response is ShowLoyaltyDialog.Data =>
  Boolean((response as ShowLoyaltyDialog.Data).loyaltyPoints);

export const isAddToBasketSuccessResponse = (
  response: AddToBasketResponse,
): response is BasketUpdated.Data => Boolean((response as BasketUpdated.Data).shoppingBag);
